module.exports = __webpack_public_path__ + "static/media/like.ab74c147.svg";